export const Api_Url = `https://cmsdemoapi.scizers.com`
